import { useState } from "react";
import { useApiInfoContextValueHook } from "../../../../../contexts/ApiInfoContextProvider";
import { useQueryParamsHook } from "../../../../../hooks/useQueryParamsHook";
import { SellertoolSignatureUtils } from "../../../../../utils/sellertool-signature-utils";
import axios from "axios";
import { customToast } from "../../../../../components/toast/custom-react-toastify/v1";
import * as St from './index.styled';
import { CustomDialog } from "../../../../../components/dialog/v1/CustomDialog";
import { CustomDateUtils } from "../../../../../utils/custom-date-utils";

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const WegetStageSelection = ({
    currentStage
}) => {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const queryParamsHook = useQueryParamsHook();

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [stageList, setStageList] = useState(null);

    const openModal = () => {
        setModalIsOpen(true);
        if (stageList === null) {
            const timestamp = Date.now().toString();
            const signature = SellertoolSignatureUtils().generateSigniture({
                apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
                secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
                timestamp: timestamp
            })

            const headers = {
                'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
                'x-sellertool-timestamp': timestamp,
                'x-sellertool-signiture': signature
            }

            axios.get(`${API_HOST}/inbound-stages`, {
                headers: headers
            })
                .then(res => {
                    if (res.status === 200 && res.data?.content) {
                        setStageList(res.data.content);
                    }
                })
                .catch(err => {
                    customToast.error(err.response);
                });
        }
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const handleStageSelect = (stage) => {
        queryParamsHook.setSearchParams({ stage: stage.uuid });
        closeModal();
    };

    return (
        <St.StageSelection.Container>
            <St.StageSelection.SelectionButton
                type='button'
                onClick={openModal}
            >
                {currentStage ?
                    <div>
                        <div>
                            ({currentStage?.name})
                        </div>
                        <div>
                            {currentStage?.uuid}
                        </div>
                    </div>
                    :
                    <div>
                        스테이지 선택
                    </div>
                }
            </St.StageSelection.SelectionButton>
            <CustomDialog
                open={modalIsOpen}
                onClose={closeModal}
            >
                <St.StageSelection.DialogHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake></CustomDialog.Header.Fake>
                        <CustomDialog.Header.Title>스테이지 선택</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={closeModal}></CustomDialog.Header.Close>
                    </CustomDialog.Header>
                </St.StageSelection.DialogHeader>
                <St.StageSelection.StageList>
                    {stageList?.map((stage, index) => {
                        return (
                            <St.StageSelection.StageItem
                                key={index}
                                onClick={() => handleStageSelect(stage)}
                            >
                                <div className='uuid'>
                                    ({stage.name})<br />{stage.uuid}
                                </div>
                                <div className='createdAt'>
                                    생성일 : {CustomDateUtils().formatDateToYYYYMMDD_HHMMSSFromUnixTime(stage.createdAt)}
                                </div>
                            </St.StageSelection.StageItem>
                        );
                    })}
                </St.StageSelection.StageList>
            </CustomDialog>
        </St.StageSelection.Container>
    );
};